import { PubSubEventBus } from './PubSub';

export const eventBusInstance = new PubSubEventBus();
